// extracted by mini-css-extract-plugin
module.exports = {"cus-info":"CustomerInfoForm_cus-info__1tl8C"};